module.exports = __webpack_public_path__ + "media/images/logo-a9d4e407663544249a2953e124335d67.svg";